import { observer } from "mobx-react";
import { Image } from "react-native";
import type { SpeciesInstance } from "~/mobx/entities/species/Species";

interface AnimalAvatarProps {
  specie: SpeciesInstance;
}

export const AnimalAvatar = observer(function AnimalAvatar({
  specie,
}: AnimalAvatarProps) {
  const nameInLowerCase = specie.name.toLowerCase();

  if (
    nameInLowerCase === "dog" ||
    nameInLowerCase === "hund"
    // TODO: Add more languages if needed
  ) {
    return (
      <Image
        source={require("~/assets/images/dog.png")}
        width={64}
        height={64}
        style={{ width: 64, height: 64 }}
      />
    );
  }

  if (
    nameInLowerCase === "cat" ||
    nameInLowerCase === "katt"
    // TODO: Add more languages if needed
  ) {
    return (
      <Image
        source={require("~/assets/images/cat.png")}
        width={64}
        height={64}
        style={{ width: 64, height: 64 }}
      />
    );
  }

  if (
    nameInLowerCase === "rabbit" ||
    nameInLowerCase === "kanin"
    // TODO: Add more languages if needed
  ) {
    return (
      <Image
        source={require("~/assets/images/rabbit.png")}
        width={64}
        height={64}
        style={{ width: 64, height: 64 }}
      />
    );
  }

  return null;
});
